
import { isResponseForGrouping } from './utils'

export default {
  middlewareForResponse: ({ transcripts }) => {
    if (isResponseForGrouping(transcripts)) return transcripts

    let newTranscript = []
    transcripts.forEach(transcript => {
      const { acceptedOperator, invitedOperators } = transcript;
      let invitedOperatorNicknames = invitedOperators.map(operator => operator.nickname)
      let agents = []
      if (acceptedOperator) agents.push(acceptedOperator.nickname)
      agents = [agents, ...invitedOperatorNicknames]
      invitedOperatorNicknames = invitedOperatorNicknames.join(', ');
      agents = agents.join(', ');

      newTranscript.push({
        ...transcript,
        invitedOperatorNicknames,
        agents,
      })
    })
    return newTranscript
  },
}
